import { DeferredSearchField, IconInviteOutlined, ToolbarButton } from "design-components";

export interface OperatorDetailLocationsToolbarProps {
  searchValue: string;
  onSearchTrigger: (value: string) => void;
  onFilterClick: () => void;
}

export function OperatorDetailLocationsToolbar(props: OperatorDetailLocationsToolbarProps) {
  const { searchValue, onSearchTrigger, onFilterClick } = props;

  return (
    <div className="users-toolbar operator-detail-locations-toolbar">
      <div className="users-toolbar__actions">
        <ToolbarButton
          size="small"
          className="users-toolbar__action-btn toolbar-button"
          startIcon={<IconInviteOutlined aria-hidden size={20} />}
        >
          Enable Scheduling
        </ToolbarButton>
      </div>
      <div className="users-toolbar__search-wrap operators-toolbar__search-wrap">
        <DeferredSearchField
          className="users-toolbar__search-field"
          placeholder="Search..."
          searchValue={searchValue}
          onSearchTrigger={onSearchTrigger}
          onFilterClick={onFilterClick}
          fullWidth
          size="small"
        />
      </div>
    </div>
  );
}
